import {
  ShoppingBasket, Baby, HeartPulse, Sparkles, Home, Shirt, Utensils, Pill, Dumbbell,
  Gift, ShoppingBag, Cookie, Milk, Droplets, Brush, Wine, Candy, Package, Star, Flower2, Bath,
} from "lucide-react";

export const CATEGORY_META = [
  { name: "Grocery & Food", label: "Grocery", Icon: ShoppingBasket, img: "https://images.unsplash.com/photo-1645567454567-901dc409551b",
    blurb: "Everyday UK favourites & treats", subs: ["Breakfast", "Snacks", "Drinks", "Cooking"] },
  { name: "Baby & Mother", label: "Baby", Icon: Baby, img: "https://images.unsplash.com/photo-1763478868195-1c61e84a6949",
    blurb: "Trusted care for mum & baby", subs: ["Baby Feeding", "Baby Care", "Baby Hygiene", "Baby Clothing", "Mother Care"] },
  { name: "Health & Wellness", label: "Wellness", Icon: HeartPulse, img: "https://images.unsplash.com/photo-1559087316-6b27308e53f6",
    blurb: "Vitamins, nutrition & self-care", subs: ["Vitamins", "Supplements", "Fitness Nutrition", "Healthy Food", "Personal Health"] },
  { name: "Beauty & Personal Care", label: "Beauty", Icon: Sparkles, img: "https://images.unsplash.com/photo-1612817288484-6f916006741a",
    blurb: "Premium skincare, hair & fragrance", subs: ["Skincare", "Hair Care", "Body Care", "Makeup", "Fragrance", "Men's Grooming"] },
  { name: "Home & Household", label: "Home", Icon: Home, img: "https://images.unsplash.com/photo-1707135873984-ce7b0fc47b4c",
    blurb: "Cleaning & everyday essentials", subs: ["Cleaning", "Laundry", "Kitchen", "Storage", "Home Essentials"] },
  { name: "Fashion & Lifestyle", label: "Fashion", Icon: Shirt, img: "https://images.unsplash.com/photo-1576053139778-7e32f2ae3cfd",
    blurb: "Accessories, bags & lifestyle", subs: ["Clothing", "Accessories", "Bags", "Jewellery", "Children's Fashion"] },
];

export const NAV_CATEGORIES = CATEGORY_META;

// Icon options admins can pick from for a category (stored as the string key).
export const ICON_OPTIONS = {
  ShoppingBasket, Baby, HeartPulse, Sparkles, Home, Shirt, Utensils, Pill, Dumbbell,
  Gift, ShoppingBag, Cookie, Milk, Droplets, Brush, Wine, Candy, Package, Star, Flower2, Bath,
};
export const iconByName = (name) => ICON_OPTIONS[name] || null;
export const defaultCatMeta = (name) => CATEGORY_META.find((c) => c.name === name);

export const BOX_LINKS = ["Family Box", "Baby Box", "Wellness Box", "Luxury Box", "Custom Box"];

export const GIFT_IMG = "https://images.unsplash.com/photo-1780744871735-389971c863cf";
export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/0f6aa5a9-8b1b-4ace-aaa2-8f099660006e/images/02b47092a9e847902e7b734fc6837f5441691b26d70ecfd1549aa6667267fd9e.jpeg";
